<template>
    <div class="warning-message__card">
        <div class="warning-message__header">
        <div class="warning-message__icon-container">
            <div class="icon-svg__container">
                <WarningIcon class="warning-message__icon"/>
            </div>
        </div>
        </div>
        <div class="warning-message__content">
            <slot />
        </div>
    </div>
  </template>
  
  <script>
    import WarningIcon from "@/assets/icons/warning.svg";
  
    export default {
      name: "WarningMessage",
      components: {
        WarningIcon
      },
      props: {
        value: {
          type: Boolean,
          default: false
        },
      },
      computed: {
        modalValue: {
          get() {
            return this.value;
          },
          set(val) {
            this.$emit('input', val);
          },
        },
      }
    }
  </script>
  
  <style lang="scss">
  $black: #212121;
  $dangerLight: #FFF0D5;
  $danger: #FFB020;
  
  .warning-message {
    &__card {
      width: 100%;
      display: flex;
      flex-direction: column;
      border: solid 1px $danger;
      border-radius: 5px;
    }
  
    &__header {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background-color: $dangerLight;
      border-bottom: solid 1px $danger;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      padding-top: rem(22);
      padding-bottom: rem(22);
    }
  
    &__icon {
      width: rem(24);
      height: rem(22);
    }
  
    &__icon-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  
    &__content {
      padding: rem(16);
      font-size: rem(16);
      font-weight: 500;
      color: $black;
    }
  }
  
  @media only screen and (min-width: 640px) {
    .warning-message {
      &__card {
        display: flex;
        flex-direction: row;
      }
  
      &__header {
        width: rem(77);
        height: rem(77);
        border-right: solid 1px $danger;
        border-bottom: none;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-top-right-radius: 0;
        padding: 0;
      }
  
      &__icon-container {
        width: rem(77);
      }
    }
  }
  </style>
  